import React from "react";
import countries from "i18n-iso-countries";
import { useIsAdmin } from "../hooks/useIsAdmin";
import CountrySelect from "../../common/commonUtils/CountrySelect";

const normalizeCountryCode = (value) => {
  if (!value) return "";
  const trimmed = String(value).trim();
  if (/^[a-z]{2}$/i.test(trimmed)) {
    return trimmed.toUpperCase();
  }
  try {
    const iso = countries.getAlpha2Code(trimmed, "en");
    return iso ? iso.toUpperCase() : "";
  } catch {
    return "";
  }
};


try {
  countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
} catch {}

const Filters = React.forwardRef(
  (
    {
      id = "tx-filters",
      data,
      searchTerm,
      onSearchChange,
      onCountryChange,
      getCountry,
      selectedCountry,
    },
    inputRef
  ) => {
    const isAdmin = useIsAdmin();

    const uniqueCountries = React.useMemo(() => {
      const set = new Set();
      (data || []).forEach((item) => {
        const code = normalizeCountryCode(getCountry(item));
        if (code) set.add(code);
      });
      return Array.from(set).sort();
    }, [data, getCountry]);

    const normalizedSelected = normalizeCountryCode(selectedCountry);

    return (
      <div id={id} className="filters shadow-none rounded-3 mb-3">
        <div className="d-flex flex-column flex-md-row gap-2">
          <div className="input-group">
            <span className="input-group-text bg-body">
              <i className="bi bi-search" />
            </span>
            <input
              ref={inputRef}
              type="text"
              className="form-control"
              placeholder="Search by name or phone…"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              autoComplete="off"
            />
          </div>

          {isAdmin && (
            <div className="input-group" style={{ maxWidth: 360 }}>
              <span className="input-group-text bg-body">
                <i className="bi bi-flag" />
              </span>
              <div className="form-control p-0 border-0 bg-body">
                <CountrySelect
                  value={normalizedSelected}
                  onChange={(code) => onCountryChange?.(normalizeCountryCode(code))}
                  placeholder="Filter by country"
                  isClearable
                  allowedCodes={uniqueCountries.map((code) => code.toLowerCase())}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
);

Filters.displayName = "Filters";

export default Filters;
